import { render, staticRenderFns } from "./RegionSingle.vue?vue&type=template&id=7e37c6c5&scoped=true&"
import script from "./RegionSingle.vue?vue&type=script&lang=js&"
export * from "./RegionSingle.vue?vue&type=script&lang=js&"
import style0 from "./RegionSingle.vue?vue&type=style&index=0&id=7e37c6c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e37c6c5",
  null
  
)

export default component.exports